import React from "react";
import { object, string } from "prop-types";
import SideBarCollection from "../sidebar-collection";
import "./sidebar-collection-ad.m.css";
import get from "lodash/get";
import DfpAd from "../../dfp-ad";

const SideBarCollectionWithAd = ({ collections, story }) => {
  const trending = get(collections, ["trending"], []);
  const latestStories = get(collections, ["latest-stories"], []);

  return (
    <div>
      <DfpAd adtype="mrec" />
      {collections && <SideBarCollection collection={trending} storyId={story.id} />}
      <a href="https://rebrand.ly/seithigalytlive" target="_blank" rel="noopener noreferrer">
        <img
          data-src="https://gumlet.assettype.com/kalaignarseithigal/2019-04/5509afdd-d19b-4203-a5d1-c6900ddf144a/live_banner_web.jpg"
          alt="banner"
        />
      </a>
      {collections && <SideBarCollection collection={latestStories} storyId={story.id} />}
      <div id="sideBarAd">
        <DfpAd adtype="Rectangle_1_300x600" />
      </div>
    </div>
  );
};

SideBarCollectionWithAd.defaultProps = {
  collections: {},
  story: {},
  storyId: ""
};

SideBarCollectionWithAd.propTypes = {
  collections: object,
  story: object,
  storyId: string
};
export default SideBarCollectionWithAd;
